import { AbstractControl, FormControl } from '@angular/forms';
import {
  AlarmRuleConditionOfflineConfig,
  AlarmRuleConditionType,
} from '../../../../../../../types/dtos/alarm-rule-condition.dto';
import { AlarmRuleConditionFormDto } from '../../../../../../../types/dtos/alarm-rule.dto';
import { BaseRuleCondition } from '../base-rule-condition';
import { LastActivityCondition } from './last-activity-condition';


export class LastActivityRuleCondition extends BaseRuleCondition {
  public getDescription(): string {
    return 'common.alarm-rule.condition.last-activity.description';
  }

  public getIcon(): string {
    return 'history';
  }

  public getName(): string {
    return 'common.alarm-rule.condition.last-activity.title';
  }

  public getType(): AlarmRuleConditionType {
    return AlarmRuleConditionType.LAST_ACTIVITY;
  }

  public getEditorComponent(): any {
    return LastActivityCondition;
  }

  public override configToFrom(data: AlarmRuleConditionOfflineConfig): Record<string, unknown> {
    return {
      hour: data.hour,
    };
  }

  public formToConfig(form: AlarmRuleConditionFormDto): AlarmRuleConditionOfflineConfig {
    return {
      hour: Number(form.hour),
    };
  }

  public getFromControls(): Record<string, AbstractControl> {
    return {
      hour: new FormControl(),
    };
  }
}